import styled, {css} from 'styled-components';
import {device} from '../../../styled/device';

type WrapperProps = {
  disabled?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  width: 327px;
  min-height: 44px;
  margin-bottom: 15px;

  ${props =>
    props.disabled &&
    css`
      opacity: 0.3;
      cursor: not-allowed;
    `};

  @media (max-width: ${device.mobileM}) {
    width: 100%;
  }
`;

export const RelativeWrapper = styled.div`
  position: relative;
`;

export const inputStyles = css`
  width: 100%;
  outline: none;
  margin: 0;
  font-family: Poppins, sans-serif;
  font-size: 16px;
  font-weight: 500;
  transition: background-color 0.25s ease-in-out, border-color 0.05s ease-in-out;
  color: #353945;
  background-color: #ffff;
  padding: 13px 16px;
  box-sizing: border-box;
  border-radius: 7px;
  border: 1px solid #b1b5c3;
  height: 50px;

  &::placeholder {
    font-family: 'Poppins', sans-serif;
    color: rgb(129, 129, 163);
    opacity: 1;
  }

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;
`;

type StyledInputProps = {
  empty?: boolean;
  invalid?: boolean;
  hideNumberButtons?: boolean;
  autoComplete?: string;
};

export const StyledInput = styled.input<StyledInputProps>`
  ${inputStyles};

  ${props =>
    props.type === 'number' &&
    !props.hideNumberButtons &&
    css`
      padding-right: 130px;
    `};

  ${props =>
    props.disabled &&
    css`
      cursor: not-allowed;
    `};

  ${props =>
    props.invalid &&
    css`
      border-color: #ff2467;
    `};

  @media (max-width: ${device.mobileL}) {
    &,
    &::placeholder {
      font-size: 20px;
    }
  }
`;

export const Label = styled.div`
  display: flex;
  max-width: 100%;
  font-family: 'Poppins', sans-serif;
  color: #777e91;
  font-size: 12px;
  text-transform: uppercase;
  text-align: left;
  box-sizing: border-box;
  /* margin-bottom: 5px; */

  .tooltip {
    margin-left: 5px;
  }

  @media (max-width: ${device.mobileM}) {
    font-size: 16px;
    min-height: 20px;
  }
`;
